import Axios from 'axios';
import {
  API_HOST,
  VUE_APP_PUBLIC_INSIGHT_API_HOST,
  VUE_APP_PUBLIC_INSIGHT_ACCESS_TOKEN
} from '../config/app-const';
import store from '../store';

const config = {
  baseURL: API_HOST
}

export function makeRequest(opts) {
  const requestConfig = {
    ...config,
    headers: { Authorization: `Token token=${store.getters.accessToken}` },
    ...opts
  }

  return Axios(requestConfig).then(r => r.data);
}

export function makePublicInsightApiRequest(opts) {
  const requestConfig = {
    baseURL: VUE_APP_PUBLIC_INSIGHT_API_HOST,
    headers: { Authorization: `bodhi token=${VUE_APP_PUBLIC_INSIGHT_ACCESS_TOKEN}` },
    ...opts
  }

  return Axios(requestConfig);
}